var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCumulativeReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8333 2.50004H12.35C12 1.53337 11.0833 0.833374 10 0.833374C8.91667 0.833374 8 1.53337 7.65 2.50004H4.16667C3.25 2.50004 2.5 3.25004 2.5 4.16671V15.8334C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8334V4.16671C17.5 3.25004 16.75 2.50004 15.8333 2.50004ZM10 2.50004C10.4583 2.50004 10.8333 2.87504 10.8333 3.33337C10.8333 3.79171 10.4583 4.16671 10 4.16671C9.54167 4.16671 9.16667 3.79171 9.16667 3.33337C9.16667 2.87504 9.54167 2.50004 10 2.50004ZM7.5 12.5H5.83333V15H7.5V12.5ZM10.8333 9.16671V15H9.16667V9.16671H10.8333ZM14.1667 5.83337H12.5V15H14.1667V5.83337Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCumulativeReport);
export default __webpack_public_path__ + "static/media/cumulativeReport.1a7c1dccb6b925f949349a59860f1df7.svg";
export { ForwardRef as ReactComponent };